import React, { createContext, useCallback, useEffect, useMemo, useState } from 'react';

import localeData from './localeData.json';
import sharedLocale from './locales/shared.json';
import statsLocale from './locales/stats.json';
import publicLocale from './locales/public.json';
import participantLocale from './locales/participant.json';
import adminLocale from './locales/admin.json';
import superadminLocale from './locales/superadmin.json';
import otherLocale from './locales/other.json';
import componentsLocale from './locales/components.json';

// Every key is { kk, ru }; later files win on duplicate keys
const MESSAGES = { ...localeData, ...sharedLocale, ...statsLocale, ...publicLocale, ...participantLocale, ...adminLocale, ...superadminLocale, ...otherLocale, ...componentsLocale };
const LOCALES = ['ru', 'kk'];
const STORAGE_KEY = 'esep.locale';

const LocalizationContext = createContext();

const readStoredLocale = () => {
    try {
        const v = localStorage.getItem(STORAGE_KEY);
        return LOCALES.includes(v) ? v : 'ru';
    } catch (e) { return 'ru'; }
};

const LocalizationProvider = ({ children }) => {

    const [currentLocale, setCurrentLocale] = useState(readStoredLocale);

    const setLocale = (newLocale) => {
        if (!LOCALES.includes(newLocale)) return;
        setCurrentLocale(newLocale);
        try { localStorage.setItem(STORAGE_KEY, newLocale); } catch (e) { /* private mode */ }
    };

    useEffect(() => { document.documentElement.lang = currentLocale; }, [currentLocale]);

    // t('Key') or t('Key', { n: 5 }) with {n} placeholders; falls back to ru, then to the key itself
    const t = useCallback((k, vars) => {
        const entry = MESSAGES[k];
        let s = entry ? (entry[currentLocale] ?? entry.ru ?? k) : k;
        if (vars) s = s.replace(/\{(\w+)\}/g, (m, name) => (vars[name] !== undefined ? vars[name] : m));
        return s;
    }, [currentLocale]);

    const value = useMemo(() => ({
        currentLocale, // Текущий язык
        setLocale, // Установка языка
        t // Данные локализации
    }), [currentLocale, t]);

    return (
        <LocalizationContext.Provider value={value}>
            {children}
        </LocalizationContext.Provider>
    );

};

export { LocalizationProvider, LocalizationContext, MESSAGES };
